// @ts-ignore
import * as BlueprintJsCore from 'expose-loader?exposes=BlueprintJsCore!@blueprintjs/core'
// @ts-ignore
import * as BlueprintJsSelect from 'expose-loader?exposes=BlueprintJsSelect!@blueprintjs/select'
import React from 'react'
import ReactDOM from 'react-dom'

window['BlueprintJsCore'] = BlueprintJsCore
window['BlueprintJsSelect'] = BlueprintJsSelect

import '@enablex/ui-shared/dist/theme.css'
import 'react-table/react-table.css'
import './style.scss'

import MakeMainRoutes from './app/routes'
import { initializeTranslations } from '~/app/translations'
import BasicAuthentication from '~/auth/basicAuth'

const auth = new BasicAuthentication()
const routes = <MakeMainRoutes auth={auth} />

initializeTranslations()
ReactDOM.render(<div>{routes}</div>, document.getElementById('root'))
